import React, { useEffect, useState } from "react";
import CommonPortfolioTabBarView from "presentational/portfolio/CommonPortfolioTabBarView";
import MyOutfitGroup from "container/portfolio/MyOutfitGroup";
import BookmarkList from "container/portfolio/BookmarkList";
import MyItemList from "container/portfolio/MyItemList";
import { useHistory, useLocation } from "react-router-dom";
import { withStore } from "store/storeHandler";
import PropTypes from "prop-types";

MyPortfoiloContent.propTypes = {
  onItemUploadClick: PropTypes.func.isRequired
};

function MyPortfoiloContent(props) {
  const { onItemUploadClick, BookmarkActions, MyItemActions } = props;
  const [value, setValue] = useState("mylist");

  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const { hash } = location;
    const hashText = hash.split("#")[1];

    switch (hashText) {
      case "favorites":
      case "bookmarked":
      case "myitem":
        setValue(hashText);
        break;
      default:
        break;
    }
  }, []);

  const resetBookmarkList = () => {
    BookmarkActions.removeExportedList();
  };

  const resetItemList = () => {
    MyItemActions.removeExportedList();
  };

  const handleTabBtnClick = newValue => () => {
    if (value !== "bookmarked" && newValue === "bookmarked") {
      resetBookmarkList();
    } else if (value !== "myitem" && newValue === "myitem") {
      resetItemList();
    }

    switch (newValue) {
      case "mylist":
        history.replace(location.pathname);
        break;
      case "favorites":
      case "bookmarked":
      case "myitem":
        history.replace(`${location.pathname}#${newValue}`);
        break;
      default:
        break;
    }

    setValue(newValue);
  };

  return (
    <div>
      <CommonPortfolioTabBarView
        tabBarType={"myTabBar"}
        value={value}
        onTabBtnClick={handleTabBtnClick}
      />
      <div>
        {(value === "mylist" || value === "favorites") && (
          <MyOutfitGroup value={value} onTabBtnClick={handleTabBtnClick} />
        )}
        {value === "bookmarked" && <BookmarkList />}
        {value === "myitem" && (
          <MyItemList onItemUploadClick={onItemUploadClick} />
        )}
      </div>
    </div>
  );
}

export default withStore({
  dispatchMap: ["bookmark", "myItem"]
})(MyPortfoiloContent);
